import { ExternalLink, Globe, FileText } from "lucide-react";
import { Layout } from "./LegalPage";
import { getLang } from "../i18n";

const CONTRACT = "0x47935d80e63eddf23f351db33b2363b6925f1530";
const POLYGONSCAN = `https://polygonscan.com/address/${CONTRACT}`;
const SITE = "https://ustp.it";

const copy = {
  it: {
    title: "USTP — White Paper",
    updated: "Versione 0.2 · Documento preliminare · 1 novembre 2026",
    blockchain: "Blockchain: Polygon",
    s1: {
      title: "Introduzione",
      p: [
        "USTP — Universe Score Token Protocol — nasce dall'incontro tra musica, creatività umana e tecnologia blockchain, con l'obiettivo di sviluppare un progetto internazionale che unisca innovazione, cultura e solidarietà.",
        "Il progetto prende origine da Universe, composizione musicale strumentale scritta da Abacico (pseudonimo di un compositore italiano) e intende utilizzare USTP come strumento per favorire la partecipazione di una comunità, la diffusione culturale e lo sviluppo di iniziative sociali e umanitarie.",
        "USTP è costruito sulla blockchain Polygon e si propone di sviluppare progressivamente un ecosistema nel quale tecnologia, arte e responsabilità sociale possano convivere.",
      ],
    },
    s2: {
      title: "Origine e visione",
      p: [
        "Universe rappresenta il nucleo creativo del progetto. La musica è il punto di partenza di una visione che considera la creatività umana una risorsa capace di creare connessioni tra persone, culture e comunità, speranza e consapevolezza.",
        "USTP intende valorizzare il rapporto tra arte e innovazione, anche attraverso l'utilizzo consapevole di strumenti digitali e intelligenza artificiale come supporto alla comunicazione.",
        "La missione del progetto è promuovere un ecosistema aperto alla collaborazione, alla diffusione culturale e allo sviluppo di iniziative con la finalità di contribuire alla costruzione di un mondo migliore.",
        "USTP si pone anche l'obiettivo di rendere sensibili gli individui di tutto il mondo sui rischi concreti dell'utilizzo e dello sviluppo indiscriminato dell'Intelligenza Artificiale.",
      ],
    },
    s3: {
      title: "Il token USTP",
      p1: "USTP è un token basato sulla blockchain Polygon. Le sue caratteristiche tecniche, l'offerta totale, la distribuzione attuale e le informazioni relative all'ICO sono descritte nella home page e nella eventuale pagina che pubblicheremo.",
      lead: "Per approfondire: ",
      link: "USTP — Tokenomics e Trasparenza",
      suffix: " sul sito ufficiale.",
      contract: "Smart contract",
      poly: "Verifica su PolygonScan",
    },
    s4: {
      title: "Pre-ICO in fase attuale",
      p: [
        "Verranno conferiti token USTP ad Angel investors fino al 3% della Total supply al fine di ottenere le prime risorse necessarie per l'avvio del progetto.",
        "La Total supply è a numero chiuso, non è possibile creare altri token USTP.",
      ],
    },
    s5: {
      title: "ICO prevista per gennaio 2027",
      p: [
        "Il progetto prevede un ICO (Initial Coin Offering) nel corso di gennaio 2027, durante la quale intende rendere disponibili per lo scambio MATIC/USTP fino a 7 miliardi di USTP, pari al 10% dell'offerta totale.",
        "La data esatta di avvio, le modalità di partecipazione e le condizioni definitive saranno comunicate attraverso i canali ufficiali del progetto www.ustp.it.",
      ],
    },
    s6: {
      title: "Musica e finalità benefiche",
      p: [
        "Uno degli obiettivi centrali di USTP è collegare la diffusione dell'opera Universe a iniziative di solidarietà e contemporaneamente alla crescita dei mezzi con cui tale opera intende veicolare il suo messaggio nel mondo.",
        "Abacico intende donare il 50% dei diritti d'autore di Universe a enti che perseguono finalità benefiche.",
        "L'obiettivo è contribuire al sostegno di attività sociali e umanitarie attraverso la valorizzazione della creatività umana.",
        "La donazione sarà formalizzata mediante accordi che specifichino i diritti interessati, gli enti beneficiari e le modalità di gestione dei relativi proventi.",
      ],
    },
    s7: {
      title: "Onlus «Rete dell'Abbondanza Universale»",
      p: [
        "Il progetto intende promuovere la costituzione di una fondazione denominata Rete dell'Abbondanza Universale.",
        "La futura fondazione si propone di sostenere e favorirne la costruzione secondo le proprie risorse e nel rispetto della normativa applicabile, di comunità volte all'autosostentamento alimentare ed energetico lontano dai centri abitati, progetti umanitari e attività con finalità solidali che, come fulcro, abbraccino i diritti fondamentali dell'uomo.",
        "La costituzione di tale Onlus avrà luogo secondo le norme previste dalla legge, uno statuto e regole di gestione e rendicontazione trasparenti.",
      ],
    },
    s8: {
      title: "Roadmap",
      intro: "Le principali direttrici di sviluppo sono:",
      items: [
        { k: "Documentazione:", v: " completamento e aggiornamento del White Paper e della documentazione informativa di USTP." },
        { k: "Preparazione dell'ICO:", v: " definizione delle modalità di distribuzione, delle condizioni operative e delle informazioni necessarie ai partecipanti." },
        { k: "ICO:", v: " avvio previsto per gennaio 2027, subordinato alla preparazione tecnica, organizzativa e normativa. L'ICO avverrà in modalità DeFi con scambio Matic/USTP." },
        { k: "Sviluppo culturale:", v: " valorizzazione e diffusione dell'opera Universe attraverso la concessione dei diritti editoriali dell'opera ad una azienda Music Publishing, la quale si occuperà della commercializzazione del brano (esempio: licenze di sincronizzazione su film)." },
        { k: "Domanda di adesione negli Exchange:", v: " richiesta di adesione del token USTP (listing) in Exchanges." },
        { k: "Iniziative benefiche:", v: " formalizzazione della donazione dei diritti d'autore e avvio delle procedure per la costituzione della fondazione «Rete dell'Abbondanza Universale»." },
      ],
      foot: "Le date e le fasi potranno essere aggiornate in base ai progressi effettivi.",
    },
    s9: {
      title: "Rischi e aspetti normativi",
      p: [
        "Questo White Paper ha finalità informative e non costituisce, da solo, un'offerta al pubblico o una consulenza finanziaria, legale o fiscale.",
        "La donazione dei diritti d'autore da parte di Abacico e la costituzione della Fondazione verranno formalizzate nel rispetto delle norme applicabili.",
      ],
    },
    s10: {
      title: "Conclusione",
      p: [
        "USTP nasce dall'incontro tra un'opera musicale, la tecnologia blockchain e una visione orientata alla collaborazione e alla concreta valorizzazione ed applicazione della carta dei diritti dell'Uomo a livello Globale.",
        "Il progetto intende sviluppare una comunità internazionale, promuovere la trasparenza e perseguire iniziative culturali e umanitarie, distinguendo chiaramente gli obiettivi futuri dai risultati già realizzati.",
        "La diffusione dell'opera Universe, la donazione prevista del 50% dei diritti d'autore di Universe e la costituzione della Fondazione Onlus «Rete dell'Abbondanza Universale» rappresentano i tre elementi centrali di questa visione.",
      ],
      quote: "USTP — Tecnologia, valorizzazione della creatività umana come strumenti di connessione per un reale contributo al cambiamento della società e costruzione di un nuovo mondo.",
    },
    ref: {
      title: "Riferimenti",
      site: "Sito ufficiale:",
      tok: "Tokenomics e Trasparenza:",
      contract: "Smart contract Polygon:",
      foot: "Versione 0.2 — Documento preliminare, da aggiornare con le condizioni definitive dell'ICO e con gli atti relativi alle iniziative culturali e benefiche.",
    },
  },
  en: {
    title: "USTP — White Paper",
    updated: "Version 0.2 · Preliminary document · 1 November 2026",
    blockchain: "Blockchain: Polygon",
    s1: {
      title: "Introduction",
      p: [
        "USTP — Universe Score Token Protocol — was born from the meeting of music, human creativity and blockchain technology, with the goal of developing an international project that brings together innovation, culture and solidarity.",
        "The project originates from Universe, an instrumental musical composition written by Abacico (the pseudonym of an Italian composer), and intends to use USTP as a tool to foster community participation, cultural outreach and the development of social and humanitarian initiatives.",
        "USTP is built on the Polygon blockchain and aims to progressively develop an ecosystem in which technology, art and social responsibility can coexist.",
      ],
    },
    s2: {
      title: "Origin and vision",
      p: [
        "Universe represents the creative core of the project. Music is the starting point of a vision that sees human creativity as a resource capable of creating connections between people, cultures and communities, hope and awareness.",
        "USTP intends to enhance the relationship between art and innovation, also through the mindful use of digital tools and artificial intelligence as a support for communication.",
        "The project's mission is to promote an ecosystem open to collaboration, cultural outreach and the development of initiatives with the aim of contributing to building a better world.",
        "USTP also aims to raise awareness among individuals around the world about the concrete risks of the indiscriminate use and development of Artificial Intelligence.",
      ],
    },
    s3: {
      title: "The USTP token",
      p1: "USTP is a token based on the Polygon blockchain. Its technical characteristics, total supply, current distribution and ICO-related information are described on the home page and on any future page we may publish.",
      lead: "Learn more: ",
      link: "USTP — Tokenomics and Transparency",
      suffix: " on the official site.",
      contract: "Smart contract",
      poly: "Verify on PolygonScan",
    },
    s4: {
      title: "Pre-ICO (current phase)",
      p: [
        "USTP tokens will be allocated to Angel investors for up to 3% of the Total supply in order to obtain the first resources needed to launch the project.",
        "The Total supply is fixed (a closed number): it is not possible to create additional USTP tokens.",
      ],
    },
    s5: {
      title: "ICO planned for January 2027",
      p: [
        "The project plans an ICO (Initial Coin Offering) during January 2027, in which it intends to make available for the MATIC/USTP swap up to 7 billion USTP, equal to 10% of the total supply.",
        "The exact start date, participation methods and final conditions will be communicated through the project's official channels, www.ustp.it.",
      ],
    },
    s6: {
      title: "Music and charitable purposes",
      p: [
        "One of USTP's central goals is to connect the diffusion of the work Universe to solidarity initiatives and, at the same time, to the growth of the means through which the work intends to convey its message to the world.",
        "Abacico intends to donate 50% of the copyright of Universe to entities pursuing charitable purposes.",
        "The goal is to help support social and humanitarian activities through the enhancement of human creativity.",
        "The donation will be formalised through agreements specifying the rights involved, the beneficiary entities and the methods for managing the related proceeds.",
      ],
    },
    s7: {
      title: "Non-profit «Universal Abundance Network»",
      p: [
        "The project intends to promote the establishment of a foundation named Universal Abundance Network (Rete dell'Abbondanza Universale).",
        "The future foundation aims to support and favour — according to its own resources and in compliance with applicable regulations — the building of communities oriented toward food and energy self-sufficiency away from inhabited centres, humanitarian projects and activities with charitable purposes that, at their core, embrace fundamental human rights.",
        "The establishment of this non-profit will take place in accordance with the rules provided by law, with a statute and transparent management and reporting rules.",
      ],
    },
    s8: {
      title: "Roadmap",
      intro: "The main development directions are:",
      items: [
        { k: "Documentation:", v: " completion and updating of the White Paper and of USTP's informational documentation." },
        { k: "ICO preparation:", v: " definition of the distribution methods, operating conditions and information needed by participants." },
        { k: "ICO:", v: " start planned for January 2027, subject to technical, organisational and regulatory preparation. The ICO will take place in DeFi mode with a Matic/USTP swap." },
        { k: "Cultural development:", v: " enhancement and diffusion of the work Universe through the granting of the work's publishing rights to a Music Publishing company, which will handle the commercialisation of the track (example: synchronisation licences for films)." },
        { k: "Exchange listing application:", v: " application for the USTP token to be admitted (listed) on Exchanges." },
        { k: "Charitable initiatives:", v: " formalisation of the copyright donation and start of the procedures for establishing the «Universal Abundance Network» foundation." },
      ],
      foot: "Dates and phases may be updated based on actual progress.",
    },
    s9: {
      title: "Risks and regulatory aspects",
      p: [
        "This White Paper is for informational purposes and does not, on its own, constitute a public offering or financial, legal or tax advice.",
        "The copyright donation by Abacico and the establishment of the Foundation will be formalised in compliance with applicable regulations.",
      ],
    },
    s10: {
      title: "Conclusion",
      p: [
        "USTP was born from the meeting of a musical work, blockchain technology and a vision oriented toward collaboration and toward the concrete enhancement and application of the Charter of Human Rights at a global level.",
        "The project intends to develop an international community, promote transparency and pursue cultural and humanitarian initiatives, clearly distinguishing future goals from results already achieved.",
        "The diffusion of the work Universe, the planned donation of 50% of Universe's copyright and the establishment of the «Universal Abundance Network» non-profit Foundation represent the three central elements of this vision.",
      ],
      quote: "USTP — Technology and the enhancement of human creativity as tools of connection for a real contribution to changing society and building a new world.",
    },
    ref: {
      title: "References",
      site: "Official site:",
      tok: "Tokenomics and Transparency:",
      contract: "Polygon smart contract:",
      foot: "Version 0.2 — Preliminary document, to be updated with the final ICO conditions and with the deeds relating to the cultural and charitable initiatives.",
    },
  },
};

const Section = ({ n, title, children }) => (
  <section className="border-t border-slate-100 pt-7 first:border-0 first:pt-0" data-testid={`wp-section-${n}`}>
    <h2 className="flex items-baseline gap-3 font-display text-xl sm:text-2xl font-bold text-slate-900">
      <span className="font-mono text-sm text-sky-600">{String(n).padStart(2, "0")}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);

export default function WhitePaperPage() {
  const c = copy[getLang()] || copy.it;
  return (
    <Layout title={c.title} updated={c.updated}>
      <div data-testid="whitepaper-content" className="space-y-8">
        <div className="flex flex-wrap gap-2" data-testid="wp-meta">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-[#F8FAFC] px-3 py-1.5 text-xs font-semibold text-slate-600">
            <Globe size={13} className="text-sky-600" />
            <a href={SITE} target="_blank" rel="noopener noreferrer" className="hover:text-sky-700">ustp.it</a>
          </span>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-[#F8FAFC] px-3 py-1.5 text-xs font-semibold text-slate-600">
            <FileText size={13} className="text-sky-600" />
            {c.blockchain}
          </span>
        </div>

        <Section n={1} title={c.s1.title}>
          {c.s1.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={2} title={c.s2.title}>
          {c.s2.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={3} title={c.s3.title}>
          <p>{c.s3.p1}</p>
          <p>
            {c.s3.lead}
            <a href="/tokenomics" target="_blank" rel="noopener noreferrer" className="font-semibold text-sky-700 underline underline-offset-2">
              {c.s3.link}
            </a>
            {c.s3.suffix}
          </p>
          <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{c.s3.contract}</p>
            <p className="mt-2 break-all font-mono text-sm font-semibold text-slate-900">{CONTRACT}</p>
            <a
              href={POLYGONSCAN}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wp-polygonscan-link"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-sky-600"
            >
              <ExternalLink size={16} />
              {c.s3.poly}
            </a>
          </div>
        </Section>

        <Section n={4} title={c.s4.title}>
          {c.s4.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={5} title={c.s5.title}>
          {c.s5.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={6} title={c.s6.title}>
          {c.s6.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={7} title={c.s7.title}>
          {c.s7.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={8} title={c.s8.title}>
          <p>{c.s8.intro}</p>
          <ul className="space-y-3">
            {c.s8.items.map((it, i) => (
              <li key={i} className="rounded-xl border border-slate-100 bg-[#F8FAFC] px-4 py-3">
                <span className="font-semibold text-slate-900">{it.k}</span>
                {it.v}
              </li>
            ))}
          </ul>
          <p className="text-xs text-slate-400">{c.s8.foot}</p>
        </Section>

        <Section n={9} title={c.s9.title}>
          {c.s9.p.map((t, i) => <p key={i}>{t}</p>)}
        </Section>

        <Section n={10} title={c.s10.title}>
          {c.s10.p.map((t, i) => <p key={i}>{t}</p>)}
          <blockquote className="rounded-2xl border-l-4 border-sky-500 bg-sky-50/70 px-5 py-4 font-serif-accent text-base sm:text-lg italic text-slate-800">
            {c.s10.quote}
          </blockquote>
        </Section>

        <div className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm" data-testid="wp-reference">
          <h3 className="font-display text-lg font-bold text-slate-900">{c.ref.title}</h3>
          <div className="mt-4 space-y-2 text-sm">
            <p>
              <span className="font-semibold text-slate-900">{c.ref.site}</span>{" "}
              <a href={SITE} target="_blank" rel="noopener noreferrer" className="font-semibold text-sky-700 underline underline-offset-2">
                https://ustp.it
              </a>
            </p>
            <p>
              <span className="font-semibold text-slate-900">{c.ref.tok}</span>{" "}
              <a href="/tokenomics" target="_blank" rel="noopener noreferrer" className="font-semibold text-sky-700 underline underline-offset-2">
                /tokenomics
              </a>
            </p>
            <p className="break-all">
              <span className="font-semibold text-slate-900">{c.ref.contract}</span>{" "}
              <span className="font-mono text-slate-700">{CONTRACT}</span>
            </p>
          </div>
          <p className="mt-4 text-xs text-slate-400">{c.ref.foot}</p>
        </div>
      </div>
    </Layout>
  );
}
